import React from "react";
import "./style.css";
import axios from "axios";
import { serverApi } from "../../confing/confing";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
const Bill = () => {

    const {id} = useParams()
    useEffect(()=>{
       try{
        const fetchData = async()=>{
            console.log(`${serverApi}pay/bill/${id}`)
            const {data} = await axios.get(`${serverApi}pay/bill/${id}`)
            console.log(data)
           
        }
     

        fetchData();
       }catch(err){
        console.log(err)
       }
    },[])

  return (
    <div>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center bill-header p-4">
        <div className="bill-header-1 mb-2">
          <p className="mb-0">شماره فاکتور</p>
        </div>
        <div className="bill-header-1 mb-2">
          <p className="mb-0">تاریخ کارشناسی</p>
        </div>
        <div className="bill-header-1 mb-2">
          <p className="mb-0">وضعیت پرداخت</p>
        </div>
      </div>
      <div className="mt-4">
      <h2 style={{color:"#81A9B8" , fontWeight:800}}>
      صورت حساب
      </h2>
      </div>
      <div className="mt-5 bill-content-box">
      <div style={{marginTop:"-40px"}}>
      <div className=" bill-content-box-title" >
      <p>مشخصات خریدار</p>
      </div>
      <div className="mt-4 me-4 text-end">
      <p>نام</p>
      <p>شماره تماس</p>
      </div>
      </div>
      <div >
      <div className=" bill-content-box-title" >
      <p>فاکتور</p>
      </div>
      <div className="mt-4 me-4 text-end">
      <p>شرح</p>
      <p>قیمت(تومان)</p>
      </div>
      </div>
      <div >
      <div className=" bill-content-box-title" >
      <p>پرداخت</p>
      </div>
      <div className="mt-4 me-4 mb-3">
      <strong>برای انجام پرداخت،روی یکی از درگاه های زیر کلیک کنید</strong>
      <p>شماره تماس</p>
      <button className="btn" style={{backgroundColor:"#EF971C"}}>
      همینک پرداخت کنید
      </button>
      </div>
      </div>
      </div>
    </div>
  );
};

export default Bill;
